import { useEffect } from 'react';
import { useLeadForm } from '../context/LeadFormContext';
import LeadForm from './LeadForm';
import './LeadFormPopup.css';

export default function LeadFormPopup() {
  const { isOpen, closeLeadForm } = useLeadForm();

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') closeLeadForm();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeLeadForm]);

  if (!isOpen) return null;

  const handleSuccess = () => {
    window.setTimeout(closeLeadForm, 2000);
  };

  return (
    <div
      className="lead-form-popup-backdrop"
      role="presentation"
      onClick={closeLeadForm}
    >
      <div
        className="lead-form-popup"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lead-form-popup-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="lead-form-popup-close"
          onClick={closeLeadForm}
          aria-label="Close form"
        >
          ✕
        </button>
        <LeadForm
          title="Get Your Free Map Update Quote"
          onSuccess={handleSuccess}
          popup
        />
      </div>
    </div>
  );
}
